// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Eventos_introTextContainer__P\\+AmR {
    text-align: center;
    margin: 20px auto;
    padding: 40px 10px;
    max-width: 800px;
}

.Eventos_title__UhI9t {
    font-size: 1.8rem;
    font-weight: bold;
    color: #555;
    margin-bottom: 10px;
}

.Eventos_subtitle__xoXaI {
    font-family: "Space Grotesk", sans-serif;
    font-weight: 700;
    font-size: 2.5rem;
    color: #1e1e1e;
    margin-bottom: 15px;
    margin-top: 10px;
}

.Eventos_description__bhArw {
    font-size: 1.2rem;
    color: #666;
    line-height: 1.5;
    margin-bottom: 30px;
}

.Eventos_calendarContainer__nSsu9 {
    display: flex;
    justify-content: center;
    margin-bottom: 2rem;
    margin-top: 20px;
    padding: 0 20px;
}

/* Tornar o calendário adaptável */
.Eventos_calendarContainer__nSsu9 iframe {
    width: 100%;
    max-width: 800px; /* Limite para telas maiores */
    height: 500px;
    border: none;
}

/* Responsividade para telas menores */
@media (max-width: 768px) {
    .Eventos_title__UhI9t {
        font-size: 1.6rem;
    }

    .Eventos_subtitle__xoXaI {
        font-size: 1.75rem;
    }

    .Eventos_description__bhArw {
        font-size: 1rem;
    }

    .Eventos_calendarContainer__nSsu9 iframe {
        height: 400px;
    }
}

@media (max-width: 480px) {
    .Eventos_subtitle__xoXaI {
        font-size: 1.5rem;
    }

    .Eventos_description__bhArw {
        font-size: 0.9rem;
    }

    .Eventos_calendarContainer__nSsu9 iframe {
        height: 350px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Site/Eventos/Eventos.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA,kCAAkC;AAClC;IACI,WAAW;IACX,gBAAgB,EAAE,8BAA8B;IAChD,aAAa;IACb,YAAY;AAChB;;AAEA,sCAAsC;AACtC;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".introTextContainer {\r\n    text-align: center;\r\n    margin: 20px auto;\r\n    padding: 40px 10px;\r\n    max-width: 800px;\r\n}\r\n\r\n.title {\r\n    font-size: 1.8rem;\r\n    font-weight: bold;\r\n    color: #555;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.subtitle {\r\n    font-family: \"Space Grotesk\", sans-serif;\r\n    font-weight: 700;\r\n    font-size: 2.5rem;\r\n    color: #1e1e1e;\r\n    margin-bottom: 15px;\r\n    margin-top: 10px;\r\n}\r\n\r\n.description {\r\n    font-size: 1.2rem;\r\n    color: #666;\r\n    line-height: 1.5;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.calendarContainer {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-bottom: 2rem;\r\n    margin-top: 20px;\r\n    padding: 0 20px;\r\n}\r\n\r\n/* Tornar o calendário adaptável */\r\n.calendarContainer iframe {\r\n    width: 100%;\r\n    max-width: 800px; /* Limite para telas maiores */\r\n    height: 500px;\r\n    border: none;\r\n}\r\n\r\n/* Responsividade para telas menores */\r\n@media (max-width: 768px) {\r\n    .title {\r\n        font-size: 1.6rem;\r\n    }\r\n\r\n    .subtitle {\r\n        font-size: 1.75rem;\r\n    }\r\n\r\n    .description {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .calendarContainer iframe {\r\n        height: 400px;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .subtitle {\r\n        font-size: 1.5rem;\r\n    }\r\n\r\n    .description {\r\n        font-size: 0.9rem;\r\n    }\r\n\r\n    .calendarContainer iframe {\r\n        height: 350px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"introTextContainer": `Eventos_introTextContainer__P+AmR`,
	"title": `Eventos_title__UhI9t`,
	"subtitle": `Eventos_subtitle__xoXaI`,
	"description": `Eventos_description__bhArw`,
	"calendarContainer": `Eventos_calendarContainer__nSsu9`
};
export default ___CSS_LOADER_EXPORT___;
